import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import SyncInterval from '@databox/ember-integrations/lib/components/DataSourceSyncInterval/DataSourceSyncInterval';
import { create } from '@databox/ember-integrations/lib/components/Setup';

import type { PopupData, ReactIntegrations, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class SourcePopupSyncIntervalComponent extends PopupInnerModalComponent<PopupData.Source.ChangeSyncInterval> {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('react') declare reactService: Service.React;

	contentNode: ReactIntegrations.Root = null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.analyticsService.event(TrackingEvent.DATA_PRIORITY_UPDATE_POPUP_OPENED, {
			origin: this.popupData.trackingOrigin,
		});
	}

	@action
	setupView(node: HTMLElement) {
		this.contentNode = create(node as HTMLDivElement);

		const newProps = {
			...this.popupData,
			onRenderEnd: () => {
				this.reposition();
			},
		};
		this.reactService.render(this.contentNode, SyncInterval(newProps));
	}

	@action
	teardownView(): void {
		if (this.contentNode) {
			this.contentNode.unmount();
			this.contentNode = null;
		}
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Refresh" @size="lg" />
			<span>Change data update frequency</span>
			{{#if this.popupData.dataSource}}
				<span class="data-source">
					<span> for</span>
					<img
						class="data-source-avatar"
						src={{this.popupData.dataSource.avatar}}
						alt="Data source avatar"
					/>
					<span class="source-name">{{this.popupData.dataSource.name}}</span>
				</span>
			{{/if}}
		</div>

		<div {{didInsert this.setupView}} {{willDestroy this.teardownView}}></div>
	</template>
}
